/* istanbul ignore file */
import { array as codecArray } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { ExtendedWork } from './ExtendedWork';
import { WorkRubricItem } from './WorkRubricItem';
const PatchRubricResultResponseParser = 
/* #__PURE__ */ parsers.object([
    ['copiedItems', /* #__PURE__ */ codecArray(WorkRubricItem), 'copied_items'],
    ['submission', ExtendedWork],
]);
export class PatchRubricResultResponse extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return PatchRubricResultResponseParser.decode(input).map(res => new PatchRubricResultResponse(res));
    }
    static unsafeDecode(input) {
        return PatchRubricResultResponse.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return PatchRubricResultResponseParser.encode(data);
    }
    static schema() {
        return PatchRubricResultResponseParser.schema();
    }
}
